import { SparksFilled } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";

import styles from "./styles.module.css";

const AiChatThinkingAvatarAnimated = () => {
  return (
    <Box align="center" justify="center" className={styles.avatar}>
      <Icon src={SparksFilled} color="on-solid-primary" />
    </Box>
  );
};

export default AiChatThinkingAvatarAnimated;
